<template>
  <div class="section">
    <div class="container">
    <div class="columns is-centered is-vcentered">
      <div class="column is-narrow">
        <a href="/pdf/manual_implementacion_incubadora_cc.pdf" target="_blank"><img src="/img/manual-incubadora-cover.png" width="400" class="image is-centered" alt="Cover manual"></a>
      </div>
      <div class="column is-6 is-offset-1 has-text-centered-mobile has-text-left-tablet">
        <h1 class="title is-2 is-700">Manual de implementación</h1>
        <h1 class="subtitle is-3">de proyectos tácticos en el espacio público</h1>
          <div class="content">
          <p>Comparte aspectos necesarios a la hora de pensar un proceso de acción colectiva en el territorio.</p><p>Al mismo tiempo, ofrece una caja de herramientas y metodologías para el co-diseño de la intervención táctica y experimental.</p>
          </div>
            <a href="/pdf/manual_implementacion_incubadora_cc.pdf" target="_blank" class="button is-primary animated pulse infinite is-medium"><i class="fas fa-download fa-fw"></i>&nbsp;&nbsp;DESCARGAR</a>
          </div>
      </div>
    </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// .the-icon{
//   height: 100px;
//   margin-bottom: 30px;
// }
// .special-bg{
//   background-image: url('/img/informe/informe-cc3.jpg');
//   background-size: cover;
//   background-position: center center;
// }
// .special-bg2{
//   background-image: url('/img/informe/informe-cc5.jpg');
//   background-size: cover;
//   background-position: center center;
// }
</style>